import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token')
    },
    getters: {
        isLogin() {
            return !!localStorage.getItem('token')
        }
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        }
    },
    actions: {
        doLogin({commit}, token) {
            commit('SET_TOKEN', token)
            localStorage.setItem('token', token)
        },
        doLogout() {
            localStorage.removeItem('token')
            localStorage.clear()
        }
    },
    modules: {}
})
